import { StoreClass } from "../stores/Store";

class GtmClass {

    store:StoreClass
    push(...args){
        // if(window.gtag && typeof window.gtag === 'function'){
        //     window.gtag(...args);

        // }
        if(window.dataLayer){
            window.dataLayer.push(...args);

        }
        console.log('GTM', ...args);
    }

    setStore(store){
        this.store = store;
    }

    getVariantStr(){
        var str = '';
        this.store.sortedStepsFlat.forEach((step) => {
            // add step.name: selected option name
            let selectedOptionName = step.selectedOption?.name ?? '';
            if (selectedOptionName) {
                str += `${step.name}: ${selectedOptionName}, `;
            }
            
        });
        return str;
    }

    getProductId(){
        return this.store.product.id;
    }
    getProductName(){
        return this.store.product.name;
    }

    getPrice(){
        return String(this.store.cart.totalPrice);
    }

    getSelectedFabricStr() {
        return String(this.store.selectedCategory?.name).toLowerCase() + " - " + String(this.store.selectedFabric?.name).toLowerCase();
    }

    

}

const Gtm = new GtmClass();


export {
    Gtm,
    GtmClass
}
